import { CustomCodeSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import DOMPurify from 'dompurify';
import { useComposerSection } from '../../content-composer/hooks/use-composer-section';
import { SectionFrame } from '../atoms/section-frame';

export const CustomCodeOutput = () => {
  const { props } = useComposerSection<CustomCodeSection>();

  if (!props.code) return null;
  const sanitizedCode = DOMPurify.sanitize(props.code);

  return <SectionFrame alignment='left' dangerouslySetInnerHTML={{ __html: sanitizedCode }} />;
};
